module.exports = __webpack_public_path__ + "img/Yos_Adiguna_Ginting.28e11e8b.png";